import type {
  ActiveOfferSetRes,
  CurrentSportYearRecord,
  MenuResponse,
  SiteResponse,
  SlimSiteResponse,
  SportFilter,
} from '@on3/api';
import React, { createContext, useContext, useMemo } from 'react';

import { type PageType } from '../types/common-props';

export interface SiteServerProps {
  currentSite: SiteResponse;
  defaultYears: CurrentSportYearRecord;
  menuData: MenuResponse[] | null;
  rankingSports?: SportFilter[] | null;
  scheduleSports?: SportFilter[] | null;
  secondaryMenuData: MenuResponse[] | null;
  trendingMenuData: MenuResponse[] | null;
  siblingSite?: SiteResponse | null;
  siteUrls: SlimSiteResponse[];
  sportsData: SportFilter[];
  subscriptionData: ActiveOfferSetRes | null;
}

export interface ISiteContext
  extends Omit<SiteServerProps, 'scheduleSports' | 'subscriptionData'> {
  pageType: PageType;
}

const defaultContext: ISiteContext = {
  siteUrls: [],
  currentSite: {} as SiteResponse,
  siblingSite: {} as SiteResponse,
  menuData: null,
  secondaryMenuData: null,
  trendingMenuData: null,
  sportsData: [],
  rankingSports: [],
  defaultYears: {} as CurrentSportYearRecord,
  pageType: 'other',
};

const SiteContext = createContext<ISiteContext>(defaultContext);

interface ISiteContextProps extends ISiteContext {
  children: React.ReactNode;
}

export const SiteProvider = ({
  children,
  ...contextProps
}: ISiteContextProps) => {
  const contextValue = useMemo(() => contextProps, [contextProps]);

  return (
    <SiteContext.Provider value={contextValue}>{children}</SiteContext.Provider>
  );
};

export const useSite = (): ISiteContext => useContext(SiteContext);
